/**
 * Filtering the FAQ.
 *
 * Fourteen questions is more than anyone reads top to bottom, so the page
 * offers a box that hides everything not matching. The questions are already
 * in the HTML — this only hides them — so the page works fully without it and
 * search engines still see every answer.
 *
 * Matching is on the question and its answer, because people search for the
 * word in the answer ("Klarna") as often as the one in the question.
 */
(function () {
  'use strict';

  function init(root) {
    var input = root.querySelector('[data-tc-faq-input]');
    var count = root.querySelector('[data-tc-faq-count]');
    var items = [].slice.call(root.querySelectorAll('[data-tc-faq-q]'));
    var groups = [].slice.call(root.querySelectorAll('[data-tc-faq-group]'));
    if (!input || !items.length) return;

    items.forEach(function (item) {
      item.__hay = (item.textContent || '').toLowerCase();
    });

    function apply() {
      var term = input.value.trim().toLowerCase();
      var shown = 0;

      items.forEach(function (item) {
        var hit = !term || item.__hay.indexOf(term) !== -1;
        item.hidden = !hit;
        if (hit) shown++;
        // Open a match so the words being searched for are visible, and close
        // it again when the box is cleared.
        if (term && hit) item.open = true;
        if (!term) item.open = false;
      });

      // A category with nothing left in it is just a heading over a gap.
      groups.forEach(function (group) {
        var any = [].slice.call(group.querySelectorAll('[data-tc-faq-q]'))
          .some(function (q) { return !q.hidden; });
        group.hidden = !any;
      });

      if (count) {
        count.textContent = !term ? ''
          : shown === 0 ? 'Nothing matches “' + input.value.trim() + '” — try fewer words, or ask us.'
          : shown + (shown === 1 ? ' question' : ' questions') + ' match';
      }
    }

    input.addEventListener('input', apply);
    input.addEventListener('search', apply);
    apply();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-tc-faq]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    [].slice.call(e.target.querySelectorAll('[data-tc-faq]')).forEach(init);
  });
})();
